import { Helmet } from "react-helmet-async";

const SEO = ({ 
  title, 
  description, 
  keywords,
  canonical 
}) => {
  const siteTitle = "Nymphea Tattoo";
  const fullTitle = title ? `${title} | ${siteTitle}` : `${siteTitle} | Tatoueuse Les Sables-d'Olonne, Vendée`;
  const defaultDescription = "Nymphea, tatoueuse spécialisée en fine line et tatouages minimalistes aux Sables-d'Olonne, Vendée. Flashs disponibles, projets personnalisés.";
  const defaultKeywords = "tatouage Les Sables-d'Olonne, tatoueuse Vendée, tattoo fine line, tatouage minimaliste, flash tattoo, Nymphea tattoo";

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description || defaultDescription} />
      <meta name="keywords" content={keywords || defaultKeywords} />
      {canonical && <link rel="canonical" href={canonical} />}
      
      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description || defaultDescription} />
      
      {/* Twitter */}
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description || defaultDescription} />
    </Helmet>
  );
};

export default SEO;
